/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LineageAttachedEntity = {
    datasourceType: LineageAttachedEntity.datasourceType;
    lastExecutionDate?: number;
    lastRunStatus: LineageAttachedEntity.lastRunStatus;
    name: string;
    type: LineageAttachedEntity.type;
    urn: string;
};

export namespace LineageAttachedEntity {

    export enum datasourceType {
        ATHENA = 'ATHENA',
        BIGQUERY = 'BIGQUERY',
        REDSHIFT = 'REDSHIFT',
        SNOWFLAKE = 'SNOWFLAKE',
        DATABRICKS = 'DATABRICKS',
        MSSQL = 'MSSQL',
        MYSQL = 'MYSQL',
        POSTGRES = 'POSTGRES',
        ORACLE = 'ORACLE',
        SYNAPSE = 'SYNAPSE',
        LOOKER = 'LOOKER',
        POWER_BI = 'POWER_BI',
        QUICKSIGHT = 'QUICKSIGHT',
        TABLEAU = 'TABLEAU',
        MICROSTRATEGY = 'MICROSTRATEGY',
        QLIK = 'QLIK',
        AIRFLOW = 'AIRFLOW',
        MWAA = 'MWAA',
        COMPOSER = 'COMPOSER',
        DBT = 'DBT',
        DBTCLOUD = 'DBTCLOUD',
        FIVETRAN = 'FIVETRAN',
        ADF = 'ADF',
        DATABRICKS_JOBS = 'DATABRICKS_JOBS',
        ATLAN = 'ATLAN',
        DECLARATIVE = 'DECLARATIVE',
        _UNKNOWN_ = '_UNKNOWN_',
    }

    export enum lastRunStatus {
        QUEUED = 'QUEUED',
        RUNNING = 'RUNNING',
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
        SKIPPED = 'SKIPPED',
        CANCELLED = 'CANCELLED',
        TIMED_OUT = 'TIMED_OUT',
        BLOCKED = 'BLOCKED',
        UNKNOWN = 'UNKNOWN',
    }

    export enum type {
        SCHEMA = 'SCHEMA',
        DATABASE = 'DATABASE',
        TABLE = 'TABLE',
        DYNAMIC_TABLE = 'DYNAMIC_TABLE',
        EXTERNAL_TABLE = 'EXTERNAL_TABLE',
        VIEW = 'VIEW',
        MATERIALIZED_VIEW = 'MATERIALIZED_VIEW',
        SNOWFLAKE_STREAM = 'SNOWFLAKE_STREAM',
        DASHBOARD = 'DASHBOARD',
        REPORT = 'REPORT',
        MODEL = 'MODEL',
        DAG = 'DAG',
        ORCHESTRATOR = 'ORCHESTRATOR',
        FIELD = 'FIELD',
        MONITOR = 'MONITOR',
        NONE = 'NONE',
        TRANSFORMATION = 'TRANSFORMATION',
        CONNECTOR = 'CONNECTOR',
        ML_MODEL = 'ML_MODEL',
        DECLARED_ASSET = 'DECLARED_ASSET',
        PIPELINE = 'PIPELINE',
        APP = 'APP',
        ANALYSIS = 'ANALYSIS',
        CHART = 'CHART',
        SHEET = 'SHEET',
        METRIC = 'METRIC',
        TILE = 'TILE',
        CUBE = 'CUBE',
        DATASET = 'DATASET',
        DATASOURCE = 'DATASOURCE',
        EXPLORE = 'EXPLORE',
        DATASET_REF = 'DATASET_REF',
        TABLE_REF = 'TABLE_REF',
        STREAMING_TABLE = 'STREAMING_TABLE',
        QUERY = 'QUERY',
        DROPPED_TABLE = 'DROPPED_TABLE',
        TEMP_TABLE = 'TEMP_TABLE',
        EPHEMERAL_REF = 'EPHEMERAL_REF',
        VIEW_REF = 'VIEW_REF',
        STORAGE = 'STORAGE',
        NODE = 'NODE',
    }


}
